/** Spanish UI strings for the "Matrículas" module (Fase 1; each record was called "solicitud" until 2026-10-05). Code stays in English; copy stays in Spanish. */
const S = {
	title: "Matrículas",   // antes "Estudiantes por Aprobar" (Esteban, 2026-09-24)
	newRequest: "Nueva Matrícula",
	newRemote: "Digital",
	newPresencial: "En Persona",
	reviewers: "Revisoras",
	search: "Buscar por nombre, identificación o teléfono",
	tabs: { drafts: "Borradores", submitted: "Por Revisar", returned: "Rechazadas", pendingPayment: "Pendiente Pago", enrolled: "Finalizadas" },
	onlyMine: "Solo Asignadas a Mí",
	draftsHint: "Un borrador solo lo ves tú y tu Dirección de Ventas. El que nadie retome se borra solo a las 48 horas.",
	empty: "No hay matrículas en esta bandeja.",
	col: { id: "#", student: "Alumno", course: "Curso / Horario", schedule: "Horario", advisors: "Asesoras", mode: "Tipo", status: "Estado", assignedTo: "Admisiones", createdBy: "Envió", caja: "Cajera", updatedAt: "Actualizada" },
	mode: "Tipo de Matrícula",
	modeRemote: "Digital",   // antes "Remota" (Esteban, 2026-09-23)
	modePresencial: "En Persona",
	student: "Alumno",
	existingStudent: "Alumno Actual o Reingreso",
	newStudent: "Alumno Nuevo",
	searchStudent: "Buscar por nombre, identificación, correo o teléfono",
	noStudents: "Sin resultados.",
	selectedStudent: "Alumno Seleccionado",
	changeStudent: "Cambiar",
	duplicatesWarning: "Ya existen alumnos con esta identificación o correo. Revisa que no sea un reingreso:",
	useExisting: "Usar Este Alumno",
	fields: {
		firstName: "Nombres", lastName: "Apellidos", identificationTypeId: "Tipo de Identificación", identificationCode: "Identificación",
		birthday: "Fecha de Nacimiento", genderId: "Género", nationalityId: "Nacionalidad", countryId: "País", stateId: "Estado / Departamento", cityId: "Ciudad",
		email: "Correo", phone1: "Teléfono", phone2: "Teléfono 2", address: "Dirección", zipcode: "Código Postal", academicDegreeId: "Último Grado de Estudios",
		lastSchoolName: "Última Escuela o Colegio", currentOccupation: "Ocupación", observations: "Observaciones", tagIds: "Etiquetas", contacts: "Contactos de Emergencia",
		contactName: "Nombre", contactRelation: "Parentesco", contactMedia: "Teléfono / Medio", facebook: "Facebook", instagram: "Instagram"
	},
	addContact: "Agregar Contacto",
	select: "Seleccione...",
	schedule: "Horarios a Matricular",
	scheduleHint: "Solo aparecen los horarios que WAPP permite para este alumno (nuevo ingreso: hasta 15 días de iniciado; reingreso al mismo curso: horarios activos).",
	searchSchedules: "Buscar por curso, módulo, horario o código",
	noSchedules: "No hay horarios disponibles.",
	selectedSchedule: "Horario Elegido",
	advisors: "Asesoras",
	notes: "Nota de Matrícula",
	notesPlaceholder: "Acuerdo con el alumno, contexto de la venta... (la promoción va en su propio paso)",
	commercialTerms: "Condiciones Comerciales",
	commercialTermsPlaceholder: "Descuentos o condiciones pactadas (texto libre por ahora).",
	payment: "Pago",
	paymentType: "Forma de Pago",
	amount: "Monto",
	paidAt: "Fecha de Pago",
	recipientAccount: "Cuenta Receptora",
	paymentMethod: "Método de Pago",
	reference: "Referencia",
	presencialPaymentHint: "El cliente paga en Caja. Indica el monto acordado para que Caja lo tenga listo.",
	documents: "Documentos",
	contract: "Contrato",
	contractRegenerate: "Generar de Nuevo",
	contractView: "Ver Contrato",
	contractViewSigned: "Ver Firmado",
	contractViewGenerated: "Ver Generado",
	contractUploadSigned: "Subir Firmado",
	contractReplaceSigned: "Reemplazar Firmado",
	contractSigned: "Firmado",
	documentsHint: "Puede adjuntar varios archivos (imagen o PDF).",
	docIdStudent: "Identificación del Alumno",
	docIdGuardian: "Identificación del Padre, Madre o Tutor",
	docReceipt: "Comprobante de Pago",
	docMissing: "Falta",
	docOptional: "Opcional · si paga en efectivo en caja, déjalo vacío",
	paymentNotes: "Nota del Pago",
	paymentNotesPlaceholder: "Lo que caja necesita saber del pago",
	documentType: "Tipo",
	upload: "Subir",
	pendingUploads: "Se subirán al guardar",
	download: "Ver",
	remove: "Quitar",
	comments: "Comentarios",
	addComment: "Agregar Comentario",
	commentPlaceholder: "Escribe un comentario...",
	validationTitle: "Falta para poder enviar / aprobar:",
	saveDraft: "Guardar Borrador",
	save: "Guardar Cambios",
	submit: "Enviar a Revisión",
	submitPresencial: "Guardar y Matricular",
	approve: "Aprobar y Matricular",
	approveShort: "Aprobar",
	returnToSales: "Rechazar",
	returnPrompt: "Rechazar Matrícula",
	markError: "Marcar como Error",
	tutorTitle: "¿Quién Firma el Contrato?",
	tutorHint: "Es menor de edad: el contrato lo firma su tutor/a legal. Elige quién de sus contactos de emergencia.",
	tutorMissing: "Si no está en la lista, cierra esto y agrégalo en Contactos de emergencia (Editar).",
	tutorContinue: "Continuar",
	markErrorPrompt: "Marcar Matrícula como Error",
	markErrorHint: "Para una matrícula duplicada o hecha por equivocación. No matricula a nadie ni cuenta como venta; pasa a Finalizadas como historial y la justificación les llega por Cliq a todas las personas que la tocaron.",
	markErrorReason: "Justificación",
	markErrorPlaceholder: "Ej.: duplicada de la #123, la clienta ya la había ingresado Admisiones.",
	markedError: "Listo: la matrícula quedó marcada como error.",
	errorReason: "Justificación del Error",
	returnPlaceholder: "Qué falta o qué hay que corregir",
	returnRequired: "Escribe qué hay que corregir.",
	reassign: "Reasignar",
	reassignPrompt: "Reasignar Matrícula",
	reassignTo: "Pasársela a",
	reassignPlaceholder: "Qué necesitas que revise",
	commentOptional: "Comentario (opcional)",
	reassigned: "Matrícula reasignada.",
	edit: "Editar",
	moreActions: "Más Acciones",
	confirm: "Confirmar",
	back: "Volver",
	saving: "Guardando...",
	saved: "Matrícula guardada.",
	submitted: "Matrícula enviada a revisión.",
	approved: "Listo: el alumno queda enrolado. Cuando Caja procese el pago pasa a inscrito.",
	returned: "Rechazada: vuelve a la supervisora.",
	createdBy: "Creada por",
	assignedTo: "Asignada a",
	submittedAt: "Enviada",
	reviewedBy: "Revisada por",
	enrollmentCreated: "Inscripción al Horario",
	paymentIntentCreated: "Ticket de Caja",
	summary: "Resumen",
	detailsTitle: "Matrícula",
	requestNumber: "Nº",
	submittedAtShort: "enviada",
	subscription: "Inscripción",
	monthly: "Mensualidad",
	free: "Gratis",
	clientOnTheWay: "El cliente va en camino a Caja",
	whatToFix: "Qué Corregir",
	commentAdded: "Comentario agregado.",
	commentsGoToProfile: "Todo este movimiento queda también en el Historial de Perfil del alumno.",
	approvingIn: (segundos: number) => `Matriculando en ${segundos}...`,
	approvingHint: "Todavía puedes deshacer.",
	undo: "Deshacer",
	returnedByCaja: "Rechazada por Caja",
	resendToCaja: "Enviar a Caja",
	resendPrompt: "Enviar Comprobante Nuevo a Caja",
	newReceipt: "Comprobante Nuevo",
	attachReceipt: "Adjuntar Comprobante",
	commentForCaja: "Comentario para Caja",
	resendPlaceholder: "Qué cambió o qué debe saber Caja",
	changeSchedule: "Corregir Horario",
	changeSchedulePrompt: "Corregir Horario y Enviar a Caja",
	changeScheduleSend: "Corregir y Enviar a Caja",
	changeScheduleWhich: "Horario a Corregir",
	changeScheduleNew: "Horario Correcto",
	changeScheduleHint: "La matrícula del horario equivocado queda anulada (sin cobros) y se crea la del horario correcto, con la misma nota y asesoras. El contrato se rehace y Caja recibe el mismo comprobante.",
	changeScheduleReceipt: "Comprobante nuevo (solo si también cambió)",
	scheduleChanged: "Listo: horario corregido y enviado a Caja.",
	docRejected: "Rechazado",
	confirmResendCaja: "¿Mandar el comprobante nuevo a Caja?",
	resentToCaja: "Comprobante enviado otra vez a Caja.",
	unassigned: "Sin Asignar",
	none: "-",
	reviewersTitle: "Quién Revisa, por Turno",
	reviewersHint: "Las matrículas digitales se reparten en orden entre las revisoras activas de este plantel. Desactiva a quien esté de vacaciones o ya no revise.",
	reviewersPool: "En Rotación",
	reviewersCandidates: "Disponibles para Agregar",
	reviewersAssigned: "asignadas",
	activate: "Activar",
	deactivate: "Pausar",
	add: "Agregar",
	noCandidates: "Todas las asesoras de Admisiones del plantel ya están en la rotación.",
	fileTooBig: "El archivo supera 10 MB.",
	confirmApprove: "Se creará el alumno (si es nuevo), se matriculará en el horario elegido y Caja recibirá el pago por aplicar. ¿Continuar?",
	confirmSubmit: "¿Enviar la matrícula a revisión?",
	confirmPresencial: "Se matriculará al alumno de inmediato y Caja recibirá el aviso de cliente en camino. ¿Continuar?",
	confirmDirectaDigital: "Se matriculará al alumno de inmediato y Caja recibirá el comprobante para procesarlo. ¿Continuar?",
	studentProfileHint: "El alumno queda visible en Alumnos con su perfil, documentos e historial.",
	perPage: "por página",
	of: "de"
};

export default S;
